import React from "react"
import { CollapsableFilter } from "./collapsable_filter"

const t = (key: string) => window.i18n.t(key)

interface CompanySizeFilterProps {
  value: string[]
  sizes: string[]
  onChange: (value: string[]) => void
}

export function CompanySizeFilter({ value = [], sizes, onChange }: CompanySizeFilterProps) {
  const handleToggleSize = (size: string) => {
    const newValue = value.includes(size) ? value.filter((v) => v !== size) : [...value, size]
    onChange(newValue)
  }

  const handleClear = () => {
    onChange([])
  }

  const hasValues = value.length > 0

  return (
    <CollapsableFilter
      label={t("js.back.discover.filters.company_size.title")}
      icon="users"
      tooltip={t("js.back.discover.filters.company_size.tooltip")}
      count={value.length}
      hasValues={hasValues}
      onClear={handleClear}
    >
      <fieldset className="h-fieldset">
        {sizes.map((size) => (
          <div key={size} className="h-form-group mb-2">
            <input
              type="checkbox"
              id={`company_size-${size}`}
              className="h-checkbox"
              checked={value.includes(size)}
              onChange={() => handleToggleSize(size)}
            />
            <label htmlFor={`company_size-${size}`} className="h-label h-label--regular mb-0">
              {size}
            </label>
          </div>
        ))}
      </fieldset>
    </CollapsableFilter>
  )
}
